import { render } from "./CustomTable.vue?vue&type=template&id=082fa565&scoped=true&ts=true"
import script from "./CustomTable.vue?vue&type=script&lang=ts"
export * from "./CustomTable.vue?vue&type=script&lang=ts"

import "./CustomTable.vue?vue&type=style&index=0&id=082fa565&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082fa565"]])

export default __exports__